import type { Filter, FilterKey } from '@core/Entities/Search/SearchFilters/Filter.entity';

type FilterUpdate = {
  id: FilterKey;
  value: Filter['value'];
};

export const updateFilters = (filters: Filter[], updates: FilterUpdate[]): Filter[] => {
  const updatedFilterIds = new Set(updates.map(({ id }) => id));

  return [
    ...filters.filter(({ id }) => !updatedFilterIds.has(id)),
    ...updates.filter(({ value }) => value !== undefined).map(({ id, value }) => ({ id, value })),
  ];
};
